import { useMutation, useQueryClient } from '@tanstack/react-query'
import useAnalytics, { AnalyticsEvents } from 'common/hooks/useAnalytics'
import { useSnackbar } from 'notistack'
import { useTranslation } from 'react-i18next'

import { createFarm, createNoteFarm, editFarm, removeFarm } from '.'
import { useFarms, useFarmsWeather } from './queries'
import { getFarmWeatherKey } from 'common/constants/queryKeys'

export const useMutateCreateFarm = () => {
  const { refetch } = useFarms()
  const { enqueueSnackbar } = useSnackbar()
  const { t } = useTranslation(['common'])
  const { trackEvent } = useAnalytics()

  return useMutation(createFarm, {
    onSuccess: () => {
      enqueueSnackbar(t('common:create.success'), { variant: 'success' })
      refetch()
      trackEvent(AnalyticsEvents.farmCreated)
    },
  })
}

export const useMutateEditFarm = () => {
  const queryClient = useQueryClient()
  const { refetch } = useFarms()
  const { enqueueSnackbar } = useSnackbar()
  const { t } = useTranslation(['common'])
  const { trackEvent } = useAnalytics()

  return useMutation(editFarm, {
    onSuccess: async (data, variables) => {
      enqueueSnackbar(t('common:edit.success'), { variant: 'success' })
      refetch()
      queryClient.refetchQueries(getFarmWeatherKey(variables.farmId))
      trackEvent(AnalyticsEvents.farmUpdated)
    },
  })
}

export const useMutateRemoveFarm = () => {
  const { refetch } = useFarms()
  const { enqueueSnackbar } = useSnackbar()
  const { t } = useTranslation(['common'])
  const { trackEvent } = useAnalytics()

  return useMutation(removeFarm, {
    onSuccess: () => {
      enqueueSnackbar(t('common:delete.success'), { variant: 'success' })
      refetch()
      trackEvent(AnalyticsEvents.farmDeleted)
    },
  })
}

export const useMutateCreateNoteFarm = () => {
  const { refetch } = useFarms()
  const { enqueueSnackbar } = useSnackbar()
  const { t } = useTranslation(['common'])
  return useMutation(createNoteFarm, {
    onSuccess: () => {
      enqueueSnackbar(t('common:create.success'), { variant: 'success' })
      refetch()
    },
  })
}


